import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connectModal } from 'redux-modal';
import BMXButton from '../../../../Components/Buttons/BMXButton/BMXButton';
import BMXModal from '../../../../Components/Modals/BMXModal/BMXModal';
import AttachmentsFromStorageForm from '../../Forms/AttachmentsFromStorageForm/AttachmentsFromStorageForm';

const AttachmentsFromStorageModal = (props) => {

  const formName = 'AttachmentsFromStorageModal';
  const { t } = useTranslation();
  const [step, setStep] = useState(0);
  const [steps, setSteps] = useState([
    { title: t('global:attachments.addFromStorageHeader'), error: false  }, 
  ]);
  const [isSubmit, setIsSubmit] = useState(false);
  const { handleHide, show } = props;

  const buttons = () => {
    return (
      <>
        <BMXButton
          type="subbmit"
          bmxclass="Success"          
          form={formName}
          onClick={() => setIsSubmit(true)}
        >
          {t('global:send')}
        </BMXButton>
      </>
    );
  };
  
  const setErrorHeader = (formNumber, val) => {
    steps[formNumber].error = val;
    setSteps([...steps]);
  };

  return (
    <BMXModal
      activeStep={step}
      setStep={setStep}
      open={show}
      width={'450px'}
      height={'300px'}
      onClose={handleHide}
      header={t('global:attachments.addFromStorage')}
      buttons={buttons()}
      steps={steps}
    >
      <AttachmentsFromStorageForm    steps={steps}
        isSubmit={isSubmit}
        step={step}
        setStep={setStep}
        formName={formName}
        handleHide={handleHide}
        setErrorHeader={setErrorHeader}
        {...props} />
    </BMXModal>
  );
};

export default connectModal({ name: 'AttachmentsFromStorageModal' })(AttachmentsFromStorageModal);
